<app-kontable
  id="kon_movements_account_balance"
  title="{{ 'customers.loyalty_movements' | translate }}"
  [columns]="[
    {field: 'acm_complete', title: 'movement.acm_id', filterType: textFilter},
    {field: 'card_no', title: 'customers.card_no', filterType: textFilter},
    'store_name',
    { field: 'xact_date', title: 'customers.movement_xact_date', bodyTemplate: xactDateTemplate, filterType: dateFilter },
    { field: 'xact_time', title: 'customers.movement_xact_time',bodyTemplate: xactTimeTemplate},
    'cash_desk',
    'transaction',
    'reasonDescription',
    'amount',
    'value',
    'balance'
  ]"
  [titles]="[
    
    'common.store_name',
    'loyalty.cash_desk',
    'loyalty.transaction',
    'loyalty.reason_description',
    'loyalty.amount',
    'loyalty.worth',
    'loyalty.balance'
  ]"
  [reportColumnWidth]="[115, 100, 120, 80, 65, 60, 105, 80, 160, 80, 70, 70]"
  [reportColumnType]="['STANDARD','STANDARD','STANDARD','DATE','TIME','STANDARD','STANDARD','STANDARD', 'STANDARD','STANDARD','STANDARD','STANDARD']"
  [reportColumnAlignment]="['left', 'left', 'left', 'center', 'center', 'center', 'left', 'right', 'left', 'right', 'right', 'right']"
  [isReportHor] = 'true'
  [source]="movements"
  [showGlobalFilter]="false"
  [showDetailsButton]="false"
  [showInfoButton]="true"
  [showRecoverButton]="false"
  [showAddButton]="false"
  [showEditButton]="false"
  [showDeleteButton]="false"
  [paginationType]="paginationType"
  [showDownloadExcelBtn]="movementExportExcelPermission"
  (onDownloadExcel)="downloadExcel($event)"
>
  <ng-template #xactDateTemplate data-testid="xactDateTemplate" let-row>
    {{row['xact_date'] | date: 'yyyy-MM-dd'}}
  </ng-template>
  <ng-template #xactTimeTemplate data-testid="xactTimeTemplate" let-row>
    {{ convertXactTime(row.xact_time) }}
  </ng-template>
  
<!--   <ng-template #acmTemplate data-testid="acmTemplate" let-row>
    {{row.acm_code}} - {{row.acm_description}}
  </ng-template> -->
</app-kontable>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-account-balance/loyalty-account-balance-table/loyalty-account-balance-table.component.html